import { prefixObjectValues as pre } from '../utils';

const prefix = 'certs-table';

const table = pre(
  {
    container: 'container',
    editBtn: 'edit-btn',
    deleteBtn: 'delete-btn',
    addBtn: 'add-btn',
    filterCheckbox: 'filter-checkbox',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
